import { AddressType } from './address-type.interface';
import { AddressTypeService } from './address-type.service';

const service = new AddressTypeService();

const state = {
   addressTypes: [],
};

const getters = {
   addressTypes(state: any) {
      return state.addressTypes;
   },
};

const mutations = {
   SET_ADDRESS_TYPES(state: any, addressTypes: any) {
      state.addressTypes = addressTypes;
   },
};

const actions = {
   async getAddressTypes(context: any) {
      return await service.getAddressTypes().then((response) => {
         context.commit('SET_ADDRESS_TYPES', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
